import { render, staticRenderFns } from "./productEdit.vue?vue&type=template&id=55fc890a&"
import script from "./productEdit.vue?vue&type=script&lang=ts&"
export * from "./productEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports